<template>
    <div class="page">
        <div class="stage_body">
            <div class="top_label">
                <div class="lable_name_box">
                    <span class="lable_name">分层教学</span>
                    <span class="stage_plan_name">{{plan_name}}</span>
                </div>
                <span class="el-icon-arrow-left" @click="$router.back(-1)"> 返回</span>
            </div>

            <div class="stag_list_box">
                
                <div @click="handleStageItem(item)" :class="['stag_list_item',{'stage_list_active':item.stage_name == form.level}]" v-for="(item,index) in stage" :key="index">
      
                    <div class="stag_list_item_top">
                        <div class="stag_list_item_top_left">
                            <div>
                                <span class="stage_name">{{item.stage_name}}层</span>
                                <span v-if="item.stage_name == form.level" class="stage_current">当前阶段</span>
                            </div>
                            
                            <div class="stag_list_item_top_left_time">
                                <i class="el-icon-date"></i>
                                <span>{{item.starttime}} ~ {{item.endtime}}</span>
                            </div>
                            
                        </div>
                        <div>
                            <span class="stag_list_item_top_right">{{tag_type[index]}}</span>
                        </div>
                        
                    </div>
                    <div class="stag_list_info">
                        <i class="el-icon-warning"></i>
                        <div class="stag_list_info_content">
                            <span>阶段要求：{{item.target_integral}}分 & 准确率 ≥ {{item.target_score}}%</span>
                            <span style="font-weight:700">→ 阶段考核</span>
                            <span>{{item.unqualified_count}}人未达标</span>
                        </div>
                    </div>
                    <div class="stag_list_progress">
                        <span>总人数：{{item.total_student_count}}</span>
                        <span>已达标：{{item.qualified_count}}</span>
                    </div>
                    <el-progress style="margin-top: 10px;" :show-text="false" :stroke-width="8" :color="item.qualified_rate >= 99 ? '#409EFF' : '#F56C6C'" :percentage="item.qualified_rate"></el-progress>
                    <!-- <span v-if="level == item.name || item?.is_complete !== undefined" class="stag_list_info_text">还差{{item.uncomplete_integrallist}}分 + 提升准确率至{{item.score}}%</span>
                    <span v-else class="stag_list_info_text">当前阶段未解锁</span> -->
                </div>


            </div>
            <div class="stag_info_content">
                <div class="stag_info_content_item">
                    <div class="stag_info_content_item_icon">
                        <i style="font-size:24px" class="el-icon-postcard"></i>
                    </div>
                    <div class="stag_info_content_item_right">
                        <span class="stag_info_content_item_right_name">学号登录强制</span>
                        <span class="stag_info_item_text">请使用统一注册账号登录系统，自行注册账号无法参加阶段考试。</span>
                    </div>
                </div>
                <div class="stag_info_content_item">
                    <div class="stag_info_content_item_icon">
                        <i style="font-size:24px" class="el-icon-refresh"></i>
                    </div>
                    <div class="stag_info_content_item_right">
                        <span class="stag_info_content_item_right_name">材料重置机制</span>
                        <div class="stag_info_item_text">每篇材料可重置 <span style="color:red;font-weight:bold;font-size:18px;">{{store.frequency}}</span>次，重置次数用完不可再提交。{{store.frequency}}次后可直接查看解析。</div>
                    </div>
                </div>
                <div class="stag_info_content_item">
                    <div class="stag_info_content_item_icon">
                        <i style="font-size:24px" class="el-icon-document-checked"></i>
                    </div>
                    <div class="stag_info_content_item_right">
                        <span class="stag_info_content_item_right_name">解析门槛</span>
                        <div class="stag_info_item_text">正确率<span style="color:red;font-weight:bold;font-size:18px;">≥ {{store.analysis}}%</span> 可查看答案解析；重置次数用尽后无视门槛直接解锁解析。</div>
                    </div>
                </div>
                <div class="stag_info_content_item">
                    <div class="stag_info_content_item_icon">
                        <i style="font-size:24px" class="el-icon-alarm-clock"></i>
                    </div>
                    <div class="stag_info_content_item_right">
                        <span class="stag_info_content_item_right_name">每日上限</span>
                        <div class="stag_info_item_text">每日积分上限<span style="color:red;font-weight:bold;font-size:18px;">{{store.number}}</span>分，超过不再累计，合理安排练习节奏~</div>
                    </div>
                </div>
            </div>

            <div class="stage_chart_box">
                <div class="stage_chart_left">
                    <span class="stage_chart_title">阶段学习人数统计</span>
                    <Stagechart :form="form"></Stagechart>
                </div>
            </div>
            



            <!-- <div class="top_plan_info_title">
                <img src="../../../static/image/wdbj.png"/>
                <span>分层规则</span>
            </div>
            <div class="timeline">
                <el-timeline>
                    <el-timeline-item v-for="(item,index) in stage" :key="index" :class="colorClass[index]" :timestamp="`${item.starttime_text} ~ ${item.endtime_text}`" placement="top">
                        <el-card>
                            <h4>{{ item.char }}</h4>
                            <p>{{ item.intro }}</p>
                        </el-card>
                    </el-timeline-item>
                    
                    <div class="timeline_info">
                        <span>提示1: 每日积分上限为10分，每做一篇材料获得2积分，每天超过十分不会再累计，请各位同学合理安排时间</span>
                        <span>提示2: 请不要使用自行注册的账号进行学习，阶段考试必须使用学号进行登录，使用自行注册的账号会导致无法参加考试</span>
                        <span v-if="store">提示3: 阶段学习每篇材料可以重置 <li style="color: #409EFF;display: inline-block;"> {{ store.frequency }} </li>重置次数完不可再提交，重置<li style="color: #409EFF;display: inline-block;">{{ store.frequency }}</li> 次后不论正确率是否达到都可以查看解析，每篇材料<li style="color: #409EFF;display: inline-block;"> 正确率 >= {{ store.analysis }}% </li>可查看答案解析，重做后正确率未达到{{ store.analysis }}%依然不可查看解析</span>
                    </div>
            
                </el-timeline>
            </div> -->
            
        
            <div class="top_plan_info_title">
                <span>做题记录</span>
            </div>
            <el-table
            :data="student"
            style="width: 100%;margin-top: 20px;"
            :row-class-name="tableRowClassName"
            >
            
            <el-table-column
                type="index"
                width="50">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="姓名"
                    >
                </el-table-column>
                <el-table-column
                    prop="stuid"
                    label="学号"
                    >
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.qualified == 1" type="primary">达标</el-tag>
                        <el-tag v-else type="danger">未达标</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="integrallist"
                    label="积分"
                    >
                </el-table-column>
                <el-table-column
                    prop="score"
                    label="正确率"
                    >
                </el-table-column>
                <el-table-column
                    prop="number"
                    label="做题数"
                    >
                </el-table-column>
                <el-table-column width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button
                        size="mini"
                        type="primary"
                        @click="handleStage(scope.row.uid,scope.row.uid_text)">查看</el-button>
    
                    </template>
                </el-table-column>
            </el-table>
            <Stage-submitanswer ref="stagesubmitanswer"></Stage-submitanswer>

        </div>
    </div>
</template>

<script>
import Http from "../../apis/teach";
import stagesubmitanswer from "../../../untils/stagesubmitanswer.vue";
import Stagechart from "../../../untils/chart/stagechart.vue";
import StageRightChart from "../../../untils/chart/stageright.vue";

export default {
    components:{
        'Stage-submitanswer':stagesubmitanswer,
        Stagechart,
        StageRightChart,
    },
    data(){
        return{
            colorClass:['greentimelinetitle','bluetimelinetitle','yellowtimelinetitle','redtimelinetitle'],
            stage:[],
            tableData:[],
            trem:0,
            student:[],
            store:{},
            plan_name:'',
            form:{
                plan_id:'',
                trem:0,
                level:'',
            },
            tag_type:[
                '基础构建',
                '能力进阶',
                '卓越冲刺',
                '高阶思维'
            ],
        }
    },

    created(){
        this.form.plan_id = this.$route.query.plan_id
        this.plan_name = this.$route.query.plan_name
        this.form.trem = this.$route.query.trem
        this.form.level = this.$route.query.level
        this.getStageWork()
        this.$store.dispatch('fetchConfig').then((res) => {
            this.store = res.school
        }).catch(error => {

            console.error('fetchConfig error:', error)
        })
    },


    methods:{
        getStageWork(){
            const loading = this.$loading({
                lock: true,
                text: '疯狂加载中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            Http.getStage(this.form).then((res) => {
                loading.close()
                this.stage = res.data
                // this.form.trem = res.data.trem
                // this.form.level = res.data.level
                this.getStudentStageWork()
            });
        },
        // 下方表格
        getStudentStageWork(){

            var params = {}
            params.plan_id = this.form.plan_id
            params.trem = this.form.trem
            params.level = this.form.level
            Http.studentStageWork(params).then((res) => {
                
                this.student = res.data
            });
            
        },

        handleStageItem(item){
            this.form.level = item.stage_name
            this.getStageWork()
        },



        handleStage(uid,name){
            this.$refs.stagesubmitanswer.getStageWork_(uid,this.form.trem,this.form.level,name,this.form.plan_id)
        },

        tableRowClassName({row}) {

            if (row.qualified == 0) {
                return 'danger-row';
            }
      
        }

    }
}
</script>
<style scoped>

.top_label{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);

}

/* 未达标行红色背景 */
::v-deep .danger-row {
    background-color: #fef0f0 !important;
}

::v-deep .danger-row:hover > td {
    background-color: #fde2e2 !important;
}
.top_label .el-icon-arrow-left{
    cursor: pointer;
    color: #409EFF;
}
.lable_name_box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}
.stage_plan_name{
    font-size: 14px;
    font-weight: 700;
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
}
.stage_name{
    font-size: 14px;
    font-weight: 700;
}
.stag_list_box{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 30px;
}
.stag_list_item{
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #fff;
    transition: transform 0.3s ease;
    cursor: pointer;
}

.stag_list_item:hover{
    transform: translateY(-5px);
}

.stage_list_active{
    border: 1px solid #409eff;
}


.stag_list_item_top{
    display: flex;
    justify-content: space-between;
}
.stag_list_item_top_left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}
.stag_list_item_top_left_time{
    display: flex;
    justify-content: flex-start;
    gap: 5px;
    font-size: 12px;
}
.stage_name{
    font-size: 18px;
    font-weight: 700;
}

.stag_list_item_top_left_time .el-icon-date{
    margin-top: 2.5px;
    color: #409eff;
}
.stag_list_item_top_right{
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 5px;
    background: #D9ECFF;
    font-weight: 700;
}

.stag_list_info{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 20px;
    padding: 10px;
    background: #F8FBFE;
    border-radius: 8px;
    box-sizing: border-box;
}

.stag_list_info .el-icon-warning{
    font-size: 24px;
    color: #F56C6C;
}

.stag_list_info_content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
}

.stag_list_info_text{
    display: flex;
    justify-content: flex-start;
    font-size: 12px;
    margin-top: 15px;
}
.stag_list_progress{
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-top: 15px;
}
.stag_info_content{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 25px;
}

.stag_info_content_item{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
}
.stag_info_content_item_right{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    font-size: 14px;
    text-align: left;
}
.stag_info_content_item_right_name{
    font-size: 14px;
    font-weight: 700;
}
.stag_info_content_item_icon{
    color: #409EFF;
}
.stag_info_item_text{
    opacity: 0.7;
}

.top_plan_info_title{
    display: flex;
    justify-content: flex-start;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 25px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    
    font-weight: 700;
}
.stage_current{
    font-size: 12px;
    font-weight: 700;
    color: #FF5151;
    margin-left: 10px;
}
.stage_chart_box{
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 25px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
}
.stage_chart_left{
    width: 100%;
}
.stage_chart_right{
    width: 30%;
    height: 350px;
}
.stage_chart_title{
    display: flex;
    justify-content: flex-start;
    font-weight: 700;
    color: #000000;
}

</style>